export const SupplementCommentMaxLength = 1000;
